import React, { Component } from 'react';
import ActiveIndicatorContainer from './ldapActiveIndicatorContainer';
import DefaultIndicatorContainer from './ldapDefaultIndicatorContainer';

export default class LdapServerMainDetails extends Component {

    shouldComponentUpdate(nextProps) {
        
        if (nextProps.name != this.props.name 
                || nextProps.active != this.props.active
                || nextProps.defaultMethod != this.props.defaultMethod) {
                return true;
        }
        return false;
    }

    render() {
        const componentDefaultServer = this.props.defaultMethod === true ? 
                <div className='active'>
                    <DefaultIndicatorContainer active={this.props.defaultMethod} />
                </div> : "";

        return(
            <div className='main-details'>
                <div className='server-name ellipsis'
                    title={this.props.name}>
                    {this.props.name}
                </div>
                <div className='active'>
                    <ActiveIndicatorContainer active={this.props.active} />
                </div>
                {componentDefaultServer}
            </div>
        );
    }
}